import { ContentBlock, contentQuery } from './content';
import { CarouselBlock, carouselQuery } from './carousel';
import { TitleVideoBlock, titleVideoQuery } from './titleVideo';
import { MediaBlock, mediaQuery } from '../../corporateQueries/blocks/mediaBlock';

export const blogContentModulesQueries = [mediaQuery, carouselQuery, contentQuery, titleVideoQuery].join('');

export type MappedBlogContentModules = Array<CarouselBlock | ContentBlock | TitleVideoBlock | MediaBlock>;
